import {
  IDmLoaiDangKyHocActionTypes,
} from "../../action-types/category/IDmLoaiDangKyHocActions";
import {
  IDmLoaiDangKyHocReducer,
} from "../../reducer-model/category/IDmLoaiDangKyHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmLoaiDangKyHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiDangKyHocs: [],
};

export const dmLoaiDangKyHocReducer = (
  state: IDmLoaiDangKyHocReducer = iniState,
  action: IDmLoaiDangKyHocActionTypes
): IDmLoaiDangKyHocReducer => {
  switch (action.type) {
    case "LOAI_DANG_KY_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "LOAI_DANG_KY_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiDangKyHocs: action.payload,
      };
    case "LOAI_DANG_KY_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_DANG_KY_HOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiDangKyHocEditing: action.payload,
      };
    case "LOAI_DANG_KY_HOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "LOAI_DANG_KY_HOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_DANG_KY_HOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "LOAI_DANG_KY_HOC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_DANG_KY_HOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_DANG_KY_HOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_DANG_KY_HOC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
